import { apiRequest } from './client'

/** 与 backend businessmodule 键一致 */
export type BusinessModuleKey =
  | 'work'
  | 'contest'
  | 'production_task'
  | 'marketplace'
  | 'learning'
  | 'subscription_plan'

export interface PublicBusinessCategory {
  module: string
  code: string
  name: string
  sort_order: number
}

export interface PublicBusinessCategoryList {
  items: PublicBusinessCategory[]
  total: number
  limit: number
  offset: number
}

export type BusinessCategoryListQuery = {
  module: BusinessModuleKey
  limit?: number
  offset?: number
}

async function listAll(module: BusinessModuleKey): Promise<PublicBusinessCategory[]> {
  const limit = 100
  let offset = 0
  let total = 0
  const items: PublicBusinessCategory[] = []
  do {
    const res = await apiRequest<PublicBusinessCategoryList>('/api/v1/business-categories', {
      query: { module, limit, offset },
      auth: false,
    })
    items.push(...(res.items ?? []))
    total = res.total ?? items.length
    offset += limit
  } while (items.length < total)
  return items
}

export const businessCategoriesApi = {
  list: (query: BusinessCategoryListQuery) =>
    apiRequest<PublicBusinessCategoryList>('/api/v1/business-categories', {
      query,
      auth: false,
    }),

  listAll,
}
